// Columns of the things an admin builds the product out of: lines, stations, buses and their seats,
// the GTFS feed, the marketing pages, roles and permissions, and the content tables. Without a name
// here the page prints the property as the backend spells it, which reads as English code.
export const CATALOGUE_COLUMN_LABELS: Record<string, string> = {
  ArrivalStation: "Stacioni i mbërritjes",
  DepartureStation: "Stacioni i nisjes",
  StationFromId: "Stacioni i nisjes",
  StationToId: "Stacioni i mbërritjes",
  FromLocationId: "Qyteti i nisjes",
  ToLocationId: "Qyteti i mbërritjes",
  Active: "Aktiv",
  IsDefault: "I parazgjedhur",
  StationRank: "Renditja e stacionit",
  PostalCode: "Kodi postar",
  Code: "Kodi",
  BusFloorId: "Kati i autobusit",
  ColumnIndex: "Kolona",
  RowIndex: "Rreshti",
  SeatReserved: "Ulësja e rezervuar",
  CompositionId: "Kompozicioni i ulëseve",
  BusSeatId: "Ulësja",
  AdditionalCapacity: "Kapacitet shtesë",
  SeatsFirstClass: "Ulëse, klasi i parë",
  SeatsSecondClass: "Ulëse, klasi i dytë",
  UpdateTime: "Ora e përditësimit",
  GTFSLineId: "Linja GTFS",
  GTFSShapeId: "Forma GTFS",
  ArrivalMinutesAfterDeparture: "Mbërritja, minuta pas nisjes",
  DepartureMinutesAfterDeparture: "Nisja, minuta pas nisjes",
  AllowsPickup: "Lejon hipjen",
  AllowsDropOff: "Lejon zbritjen",
  IsConfirmed: "E konfirmuar",
  ShapeId: "Identifikuesi i formës",
  Latitude: "Gjerësia gjeografike",
  Longitude: "Gjatësia gjeografike",
  StartingLatitude: "Gjerësia gjeografike (fillimi)",
  StartingLongitude: "Gjatësia gjeografike (fillimi)",
  EndingLatitude: "Gjerësia gjeografike (fundi)",
  EndingLongitude: "Gjatësia gjeografike (fundi)",
  Completed: "E përfunduar",
  GjAlToken: "Token-i GjAl",
  Version: "Versioni",
  LinePageId: "Faqja e linjës",
  Content: "Përmbajtja",
  Answer: "Përgjigjja",
  QuestionId: "Pyetja",
  Svg: "Ikona (SVG)",
  LocationDescription: "Përshkrimi i destinacionit",
  LocationImageUrl: "Fotoja e destinacionit",
  LocationUrl: "Lidhja e destinacionit",
  BundleStatus: "Statusi i paketës",
  UserName: "Përdoruesi",
  UserId: "Përdoruesi",
  UserAccountId: "Përdoruesi",
  RoleId: "Roli",
  InvitedUserId: "Përdoruesi i ftuar",
  ExpiryDate: "Skadon më",
  SystemName: "Emri në sistem",
  Scope: "Fusha e lejes",
  FileName: "Emri i skedarit",
  MimeType: "Lloji i skedarit",
  LanguageCulture: "Kodi i gjuhës",
  UniqueSeoCode: "Kodi SEO",
  DefaultLanguage: "Gjuha e parazgjedhur",
  Rtl: "Shkrim nga e djathta",
  Category: "Kategoria",
  Endpoint: "Adresa e endpoint-it",
  HttpMethod: "Metoda HTTP",
  RequiredPermission: "Leja e nevojshme",
  InputSchemaJson: "Skema e parametrave",
  MessageTemplateName: "Emri i shabllonit",
  HtmlContent: "Përmbajtja HTML",
  DynamicParameters: "Parametrat dinamikë",
  HoursToCancelBeforeDeparture: "Orë për anulim para nisjes",
  HoursToEditBeforeDeparture: "Orë për ndryshim para nisjes",
  NumberOfAllowedEdits: "Ndryshime të lejuara",
  IsUpgradeOnly: "Vetëm si përmirësim",
  MinimumCost: "Kostoja minimale",
  ValidityInDays: "Ditë vlefshmërie",
  ImageUrl: "Fotoja",
  CoverImageUrl: "Fotoja e kopertinës",
  GradientColorHex: "Ngjyra",
  IsRegional: "Zonë rajonale",
  HighRisk: "Rrezik i lartë",
  BlockedForPurchase: "E bllokuar për blerje"
};

// Foreign keys whose name does not end in "Id", so the reader of a value can still tell an empty
// link (a zero) from a number that means something.
export const LINK_COLUMNS = new Set([
  "StationFrom",
  "StationTo",
  "DepartureStation",
  "ArrivalStation"
]);
